import TitleValueList from './TitleValueList.vue';

export default TitleValueList;
